module.exports = __webpack_public_path__ + "media/images/payment_cards/credit_cards/discover-7ac6a36e42d5ea602747e70c3dd73f2d.png";